// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyB2JJsKNJYUv0q64R96-GpfnSHOaqRsWW0",
  authDomain: "cata-2021.firebaseapp.com",
  projectId: "cata-2021",
  storageBucket: "cata-2021.appspot.com",
  messagingSenderId: "247848632623",
  appId: "1:247848632623:web:f9679b596c01366ce721da",
  measurementId: "G-621YZGS2FF"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/cata-2021.appspot.com/o/'